import React, { useState, useEffect } from 'react';
import { map, get } from 'lodash';
import { getQuizGroup, createQuizGroup, delQuizGroup, getQuizExamples } from 'libs/api/learning';
import { EQuizType, CQuizTypeNum, CQuizTypeName, TQuizConnectedExamples } from 'modules/learning/quizTypes';
import { TModalProps } from 'modules/types';
import { Checkbox, Form, Typography, Col, Row, Modal, Button, Input, message } from 'antd';
import styled from 'styled-components';
import { FormWrapper, PrimaryColor, PlusOutlineIcon, MinusOutlineIcon } from 'GlobalStyles';

const { Title } = Typography;

const StyledQuizInfoSubModalWrapper = styled.div``;

const KaitusAssessmentSubModal = ({ modalState, setModalState }: TModalProps) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [quizGroupList, setQuizGroupList] = useState<
    Array<{
      id: number;
      name: string;
    }>
  >();
  const [connectedExampleList, setConnectedExampleList] = useState<Array<TQuizConnectedExamples>>();
  const [quizTypeList, setQuizTypeList] = useState<
    Array<{
      type_num: number;
      type_name: string;
    }>
  >();

  //취소 눌렀을 때 => 아무 변화 없이 모달이 꺼짐
  function handleCancel() {
    setModalState({ visible: false, record: '' });
  }

  //확인 눌렀을 때
  function onClickSubmit() {
    //==> 모달이 꺼짐
    setModalState({ visible: false, record: '' });

    //==> value 값을 onFinish의 인자로 전달하기
    const value = {
      quiz_group: quizGroupList?.find(
        (el: { id: number; name: string }) => el.id === form.getFieldValue('quiz_group')?.[0],
      ),
      connected_example: connectedExampleList?.find(
        (el: TQuizConnectedExamples) => el.id === form.getFieldValue('connected_example')?.[0],
      ),
      quiz_type: form.getFieldValue('quiz_type')?.[0],
    };

    // ==> onFinish의 인자로 전달하기
    modalState.onFinish && modalState.onFinish(value);
    // value => {quiz_group: '그룹명1'} //위에서 0번째 인덱스만 선택하도록해서 배열이 아닌 문자열로
  }

  useEffect(() => {
    setVisible(modalState.visible);
  }, [modalState.visible]);

  //add하는 input 태그 및 추가/삭제 버튼
  //추가할 때 setstate
  const getQuizGroupList = async () => {
    const { success, data } = await getQuizGroup();
    if (success) {
      setQuizGroupList(data);
    }
  };

  const getConnectedExampleList = async () => {
    const { success, data } = await getQuizExamples();
    if (success) {
      setConnectedExampleList(data);
    }
  };

  const getQuizType = async () => {
    const QUIZ_TYPE = [
      {
        type_num: 1,
        type_name: 'list',
      },
      {
        type_num: 2,
        type_name: 'index',
      },
      {
        type_num: 3,
        type_name: 'issue_tree',
      },
      {
        type_num: 4,
        type_name: 'value_chain',
      },
      {
        type_num: 5,
        type_name: 'short_answer',
      },
    ];
    setQuizTypeList(QUIZ_TYPE);
  };

  const addGroupName = async () => {
    //아무것도 입력 안했을 때는 추가 안되도록
    if (quizGroupList && form.getFieldValue('add_group')) {
      const addGroupName = form.getFieldValue('add_group');
      //post해서 등록한 후 다시 리스트 get 해와야함
      const { success } = await createQuizGroup({ name: addGroupName });
      if (success) {
        getQuizGroupList();
      }
    }
    form.resetFields();
  };

  const deleteGroupName = async (id: number) => {
    if (quizGroupList) {
      const { success } = await delQuizGroup(id);
      if (success) {
        getQuizGroupList();
      }
    }
  };

  const checkLimitNum = ({ formName }: { formName: string }) => {
    if (formName === 'quiz_group') {
      const checkGoupValue = form.getFieldValue('quiz_group');
      if (checkGoupValue !== undefined && checkGoupValue.length >= 1) {
        message.error('그룹명은 한 개만 체크할 수 있습니다');
      }
    }
    if (formName === 'connected_example') {
      const checkExamleValue = form.getFieldValue('connected_example');
      if (checkExamleValue !== undefined && checkExamleValue.length >= 1) {
        message.error('연결된 예제는 한 개만 체크할 수 있습니다');
      }
    }
  };

  useEffect(() => {
    getQuizGroupList();
    getConnectedExampleList();
    getQuizType();
  }, []);

  //다중선택하고 모달 다시 띄웠을 때 한가지 이전에 선택 반영된 것만 체크되어 있을 수 있도록
  useEffect(() => {
    if (modalState.type === 'quizGroup') {
      form.setFields([{ name: 'quiz_group', value: modalState.record }]);
    }
    if (modalState.type === 'connectedExample') {
      form.setFields([{ name: 'connected_example', value: modalState.record }]);
    }
    if (modalState.type === 'quizType') {
      form.setFields([{ name: 'quiz_type', value: modalState.record.type_name }]);
    }
  }, [modalState]);

  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={
        <Row justify='end'>
          <Button onClick={handleCancel}>닫기</Button>
          <Button type='primary' onClick={onClickSubmit}>
            적용
          </Button>
        </Row>
      }
      width={540}
      onCancel={handleCancel}
    >
      <FormWrapper style={{ padding: '0px' }}>
        {modalState.type === 'quizGroup' && (
          <StyledQuizInfoSubModalWrapper>
            <Title level={3}>문제 그룹</Title>
            <Form form={form} colon={false} className='form-normal' style={{ margin: '10px' }}>
              <Form.Item name={'quiz_group'}>
                <Checkbox.Group className='checkbox-btn'>
                  {map(quizGroupList, (v) => (
                    //하나만 선택할 수 있도록,
                    //여기서 선택한 값 onFinish 에서 데이터로 넘어갈 수 있도록
                    //빼기 버튼 추가
                    <div key={get(v, 'name')} style={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        style={{ margin: '8px 8px 8px 0' }}
                        // key={get(v, 'name')}
                        value={get(v, 'id')}
                        onChange={() => checkLimitNum({ formName: 'quiz_group' })}
                      >
                        {get(v, 'name')}
                      </Checkbox>
                      <Button className='list-minus-button' onClick={() => deleteGroupName(v.id)}>
                        <MinusOutlineIcon fill={PrimaryColor} />
                      </Button>
                    </div>
                  ))}
                </Checkbox.Group>
              </Form.Item>
              <Row justify='space-between'>
                <Form.Item name={'add_group'} className='form-item' style={{ width: '70%' }}>
                  <Input autoFocus={true} placeholder='추가할 그룹명을 입력해주세요' />
                </Form.Item>
                <Form.Item noStyle={true}>
                  <Button onClick={addGroupName}>
                    <PlusOutlineIcon fill={PrimaryColor} />
                    <span style={{ marginLeft: '5px' }}>추가</span>
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </StyledQuizInfoSubModalWrapper>
        )}
        {modalState.type === 'connectedExample' && (
          <StyledQuizInfoSubModalWrapper>
            <Title level={3}>연결된 예제</Title>
            <Form form={form} colon={false} className='form-normal' style={{ margin: '10px' }}>
              <Form.Item name={'connected_example'}>
                <Checkbox.Group className='checkbox-btn'>
                  {map(connectedExampleList, (v, index) => (
                    <div>
                      <Checkbox
                        key={index}
                        value={v.id}
                        onChange={() => checkLimitNum({ formName: 'connected_example' })}
                      >
                        {v.subject} <br /> : {v.title}
                      </Checkbox>
                    </div>
                  ))}
                </Checkbox.Group>
              </Form.Item>
            </Form>
          </StyledQuizInfoSubModalWrapper>
        )}
        {modalState.type === 'quizType' && (
          <StyledQuizInfoSubModalWrapper>
            <Title level={3}>답안지 유형</Title>
            <Form
              form={form}
              // name="QuizInfoModal"
              colon={false}
              // layout="vertical"
              className='form-normal'
              style={{ margin: '10px' }}
            >
              <Form.Item name={'quiz_type'}>
                <Checkbox.Group className='checkbox-btn'>
                  {map(quizTypeList, (v, index) => (
                    <div>
                      <Checkbox
                        key={index}
                        value={v.type_name}
                        disabled={CQuizTypeNum[v.type_name] > 3 ? true : false}
                      >
                        {`${CQuizTypeNum[v.type_name]}. ${CQuizTypeName[v.type_name]}`}
                      </Checkbox>
                    </div>
                  ))}
                </Checkbox.Group>
              </Form.Item>
            </Form>
          </StyledQuizInfoSubModalWrapper>
        )}
      </FormWrapper>
    </Modal>
  );
};
KaitusAssessmentSubModal.defaultProps = {};

export default KaitusAssessmentSubModal;
